import api from './axios';

export type PickupType = 'car' | 'foot';

export interface Student {
  id: number;
  first_name: string;
  last_name: string;
  grade: string;
  pickup_type: PickupType;
  checked_in_at: string;
  dismissed_at: string | null;
  registered_student_id?: number; // Link to pre-registered student
}

export interface CheckInPayload {
  first_name: string;
  last_name: string;
  grade: string;
  pickup_type: PickupType;
  registered_student_id?: number; // Optional link to pre-registered student
}

export const fetchStudents = async (): Promise<Student[]> => {
  console.debug('[api] Fetching students');
  const { data } = await api.get<Student[]>('/api/students');
  console.debug('[api] Fetch students success', { count: data.length });
  return data;
};

export const checkInStudent = async (payload: CheckInPayload): Promise<Student> => {
  console.debug('[api] Checking in student', payload);
  const { data } = await api.post<Student>('/api/students', payload);
  console.debug('[api] Check-in success', { id: data.id });
  return data;
};

export const dismissStudent = async (studentId: number): Promise<Student> => {
  console.debug('[api] Dismissing student', { id: studentId });
  const { data } = await api.post<Student>(`/api/students/${studentId}/dismiss`);
  console.debug('[api] Dismiss success', { id: data.id });
  return data;
};
